<template>
  <div>
    <header class="header-main_v2">
      <nav class="mobile-menu">
        <div class="menu_v2_contains">
          <div class="logo">
            <router-link to="/home" :class="['logo-header', getActiveTabClass('/home')]">
              <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo-brainiac.svg'" @click="updateBM" alt="">
            </router-link>
          </div>
          <button data-menu="dropdown_lang" class="nav__toggle nav__toggle_lang"></button>
          <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
          <div class="items">
            <a style="cursor:pointer" @click.prevent="goToNotifications"><img src="static/images/icon-notifications.svg" alt="notifications"></a>
            <nav class="main-nav">
              <ul v-if="!hideLangSelection" class="main-nav__lang" id="get_started_menu">
                <li class="dropdown">
                  <a><div class="icon-globe"><img src="static/images/icon-globe.svg" alt="globe"></div></a>
                  <ul>
                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <input type="checkbox" id="checkbox" class="mobile-menu__checkbox">
        <label for="checkbox" class="mobile-menu__btn">
          <div class="mobile-menu__icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </label>
        <div class="mobile-menu__container">
          <ul class="mobile-menu__list">
            <li v-if="!hideStore" class="mobile-menu__item">
              <router-link to="/home/store" :class="['mobile-menu__link', getActiveTabClass('/home/store')]">
                {{ getTranslations.home_home_store }}
              </router-link>
            </li>
            <li class="mobile-menu__item">
              <router-link to="/home/profile" :class="['mobile-menu__link', getActiveTabClass('home/profile')]">
                {{ getTranslations.home_home_profile }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!-- WIN INSTANTLY TODO WHAT ABOUT THIS PAGE-->
              <router-link to="/home/store" :class="['mobile-menu__link', getActiveTabClass('/home/store')]">
                {{ getTranslations.home_win_instantly }}
              </router-link>
            </li>
            <li v-if="!hideLeaderboard" class="mobile-menu__item"> <!-- PRIZES & LEADERBOARDS -->
              <router-link to="/home/prizesAndLeaderBoards" :class="['mobile-menu__link', getActiveTabClass('/home/prizesAndLeaderBoards')]">
                {{ getTranslations.home_home_prizes_and_leaderboards }}
              </router-link>
            </li>
            <li v-if="!hideWinners" class="mobile-menu__item"> <!-- WINNERS -->
              <router-link to="/home/winners" :class="['mobile-menu__link', getActiveTabClass('/home/winners')]">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/home/howItWorks" :class="['mobile-menu__link', getActiveTabClass('/home/howItWorks')]">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/home/achievements" :class="['mobile-menu__link', getActiveTabClass('/home/achievements')]">
                {{ getTranslations.home_achievements }}
              </router-link>
            </li>
            <li class="mobile-menu__item last">
              <a @click.prevent="logoutUser" style="cursor:pointer" class="mobile-menu__link">
                {{ getTranslations.home_home_log_out }}</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <router-view></router-view>
    <fade-transition>
      <component :is="currentModal"
                 @close="closeHomeModal(true)"/>
    </fade-transition>
    <fade-transition>
      <component :is="modalForHomePage" v-bind="currentProperties" @close="closeHomeModal(false)"
                 @openNewModal="openNewModal($event)"></component>
    </fade-transition>

    <subscribe-reoptin
        v-if="subscribeReoptinModalConfig.open"
        @proceed="handleSubscribeReoptinProceed"
        @close="handleCloseSubscribeReoptinModal"
    ></subscribe-reoptin>

    <simplify-registration
        v-if="subscriptionViaSmsModalConfig.open"
        :text-key="subscriptionViaSmsModalConfig.textKey"
        @close="handleCloseSubscriptionViaSmsModal"
    ></simplify-registration>
  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';
import { handleBurger, handleLanguageDropdown, openCloseTab } from '@/common/jQuery';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { listenForPushNotifications } from '@/common/serviceWorkers';
import FadeTransition from '@/components/home/sharedcomponents/FadeTransition';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';
import PrizeForFreeGame from './modals/PrizeForFreeGame';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import SpinWheelPrize from './modals/spinwheel/SpinWheelPrize';
import SubscribeReoptin from './modals/SubscribeReoptin';
import SimplifyRegistration from './modals/SimplifyRegistration';
import subscriptionMixin, { subscriptionOperationEnum } from '../../common/mixins/subscription';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  mixins: [NewGameMixin, RoundUpMixin, FacebookMixin, subscriptionMixin],
  components: {
    SubscribeReoptin,
    SimplifyRegistration,
    FadeTransition,
  },
  data() {
    return {
      currentModal: null,
      prizeModalName: null,
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      isIos: false,
      currentTabPath: null,
      showedModal: false,
      subscribeReoptinModalConfig: { open: false },
      subscriptionViaSmsModalConfig: { open: false, textKey: undefined },
    };
  },
  computed: {
    ...mapState('common', [
      'hideStore',
      'hideLangSelection',
      'hideWinners',
      'hideLeaderboard',
      'reoptinAndOptoutConfig',
      'userDetails',
      'modalForHomePage',
      'subAndUnsubViaSMS',
      'facebookFunctionality',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'unauthorizedWinnerInfo',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'firstTimeEntry',
      'notifications',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getDisplayedLocale',
    ]),
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapGetters('common', [
      'isRegistrationViaSms',
    ]),
    currentProperties() {
      if (this.modalForHomePage === SpinWheelPrize) {
        return {
          prizeInfo: {
            prizeName: this.prizeModalName,
          },
        };
      }
      return null;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path === '/home') {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    this.storeModalForHomePage(null);
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    next();
  },
  created() {
    if (localStorage.getItem('locale') !== this.getLocale) {
      this.changeLanguage(localStorage.getItem('locale'));
    }
    listenForPushNotifications();
    this.currentTabPath = sessionStorage.getItem('homeCurrentTabPath');
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserAchievements().then(() => {
      this.getBonusPhases().then(() => {
        this.getUserNotifications().then(() => {
          // example url for extra Notifications from SocketJS -- http://localhost:8181/api/sendNotifications?msisdn=300136987410
          this.stompClient = webSocket.getNotificationsStompClient();
          if (this.stompClient === null) {
            this.stompClient = webSocket.createNewStompClient('/notificationsData');
          }
          this.connect();
          if (this.bonusDailyModal) this.storeModalForHomePage(BonusDaily);
        });
      });
    });
    this.storePerformance(this.userDetails.msisdn);
  },
  mounted() {
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger(ZeroBalance);
    });
    this.autoCheckIfGameToResumeExists();
    openCloseTab();
  },
  updated() {
    // eslint-disable-next-line
    console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
        + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
        + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
          && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    ...mapActions('profile', [
      'storePerformance',
    ]),
    ...mapMutations('game', [
      'resetPrizePostGameData',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
      'awardPrizeAction',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
      'getUserAchievements',
      'getUserNotifications',
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
      'getBonusPhases',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    closeHomeModal(isCurrentModal) {
      if (isCurrentModal) this.currentModal = null; else this.storeModalForHomePage(null);
      if (!this.currentModal && !this.modalForHomePage) {
        /* eslint-disable */
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        /* eslint-enable */
      } else {
        this.showModal();
      }
    },
    openNewModal(event) {
      this.storeModalForHomePage(null);
      this.prizeModalName = event;
      this.storeModalForHomePage(SpinWheelPrize);
      this.showModal();
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
          const vm = this;
          this.$nextTick(() => {
            /* eslint-disable */
            // open modal
            $('.modal,.modal-overlay,.overlay').fadeIn(200);
            $("body").addClass("modal-open");
            // hide modal
            $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
              $(".popup_box").fadeOut(200);
              $(".overlay").fadeOut(200);
              $('.modal, .modal-overlay').fadeOut();
              $("body").removeClass("modal-open");
              /* eslint-enable */
              vm.storeModalForHomePage(null);
            });
          });
        } else {
          this.methodForPopUps();
        }
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.currentModal = WelcomeSignup;
        this.showModal();
      } else {
        if (this.unauthorizedWinnerInfo.existPrize) {
          if (this.unauthorizedWinnerInfo.msisdn === this.userDetails.msisdn) { // case where he wins a prize and login with a different user
            this.storeModalForHomePage(PrizeForFreeGame);
            this.awardPrizeAction();
            this.showModal();
          } else {
            this.resetPrizePostGameData();
          }
        } else {
          const nowDate = new Date(moment().format('L'));
          const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
          if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableGames === 0 && this.userDetails.subscribed) && (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
            this.storeModalForHomePage(ZeroBalance);
            this.showModal();
            sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
          }
          if (!this.userDetails.subscribed && (!this.bonusDailyModal) && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                if (this.isRegistrationViaSms) {
                  this.subscribeReoptinModalConfig.open = true;
                } else {
                  this.storeModalForHomePage(ResubscribeGameSms);
                }
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
            this.showModal();
          }
        }
      }
    },
    connect() {
      this.stompClient.connect({ Authorization: auth.getJwt() }, this.stompSuccess, this.stompFailure);
    },
    stompSuccess(frame) {
      clearTimeout(this.connectionTimer);
      // eslint-disable-next-line
      console.log(`In Home component: ${frame}`);
      console.log(`Inside Created ${this.userDetails.msisdn}`);
      console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
      this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
        console.log('==> Inside notification response');
        const notificationsDTO = JSON.parse(response.body);
        this.storeNotificationsFromSocket({ notifications: notificationsDTO });
        console.log('notificationsDTO');
        console.log(notificationsDTO);
      }, (errorResponse) => { // error callback
        console.log('errorResponse');
        console.log(errorResponse);
      });
    },
    stompFailure(error) {
      // console.clear();
      console.log(error);
      console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
      clearTimeout(this.connectionTimer);
      this.connectionTimer = setTimeout(() => {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
        this.connect();
      }, 3000);
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          if (this.firstTimeEntry) {
            this.setFirstTimeEntry(false);
            this.currentModal = null;
            this.methodForPopUps();
          } else {
            if (!this.showedModal) {
              console.log("----------------------- Correct Exit For  Store showHideModal");
              this.resetPrizePostGameData();
              this.showedModal = true;
              this.storeModalForHomePage(null);
            } else {
              this.storeModalForHomePage(null);
            }
          }
        });
      });
      /* eslint-enable */
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.updateUserLanguage().then(() => {
          this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
            this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
              this.facebookSDKApi().then(() => {
                this.getUserAchievements().then(() => {
                  this.getUserNotifications();
                });
                this.changeCSSFile();
                if (this.$route.path === '/home/notifications') {
                  this.$router.go(0);
                }
              });
            });
          });
        });
      });
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    goToNotifications() {
      this.$router.push('/home/notifications');
    },
    logoutUser() {
      this.closeAllStompClients();
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null) currentLocale = this.getLocale;
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0) sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      this.clearAllData();
      window.location.reload();
      this.$router.push('/');
    },
    closeAllStompClients() {
      if (this.subscription) this.subscription.unsubscribe();
      webSocket.disconnectStompClient(this.stompClient);
    },
    updateBM() {
      $('.mobile-menu__container').removeClass('open');
      $('.mobile-menu__icon').removeClass('open');
    },
    handleSubscribeReoptinProceed(subscriptionType) {
      this.handleCloseSubscribeReoptinModal();

      this.$nextTick(() => {
        this.subscriptionMixinLaunchAction(
          subscriptionOperationEnum.RESUBSCRIBE,
          subscriptionType,
          (value) => {
            this.subscriptionViaSmsModalConfig.open = true;
            this.subscriptionViaSmsModalConfig.textKey = value;
          },
        );
      });
    },
    handleCloseSubscribeReoptinModal() {
      this.subscribeReoptinModalConfig.open = false;
    },
    handleCloseSubscriptionViaSmsModal() {
      this.subscriptionViaSmsModalConfig.open = false;
      this.subscriptionViaSmsModalConfig.textKey = undefined;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue